import './PaginateButtons.scss';
import Component from './PaginateButtons.js';
export default Component;
